import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  cursor: pointer;
`;

const Path = styled.path`
  fill: ${props => props.theme.mapMarker};
`;

const Container = styled.div`
  height: 11px;
  width: 11px;
  @media (min-width: 1800px) {
    height: 16px;
    width: 16px;
  }

  @media (max-width: 575px) {
    height: 10px;
    width: 10px;
  }
`;

const Mapmarker = ({ chosen, ...props }) => {
  return chosen ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.674"
      height="32.512"
      viewBox="0 0 21.674 32.512"
    >
      <Path d="M10.837,0A11.019,11.019,0,0,0,0,11.195c0,6.177,10.837,21.317,10.837,21.317s10.837-15.14,10.837-21.317A11.019,11.019,0,0,0,10.837,0Z" />
    </svg>
  ) : (
    <Container>
      <Svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 10.643 10.643"
      >
        <circle cx="5.322" cy="5.322" r="5.322" fill="#e26a71" />
      </Svg>
    </Container>
  );
};

export default Mapmarker;
